import { Injectable } from "@angular/core";
import { CONTROLLERS, ENDPOINTS } from "src/app/constants";
import { ApiService } from "../api.service";
import { PaymentPlanDashboardReqCommand, PaymentPlanSnapshotResp, Response, PaymentPlanMethodResp, PaymentPlanTypeResp, TimeBasedSnapshotResp, PlaymentPlanActionRequiredResponse } from "src/app/models";
import { Observable, of } from "rxjs";
import { environment } from "@environment";

const API_Payment = `${environment.paymentApiUrl}`;

@Injectable({
    providedIn: 'root',
})
export class PaymentPlanDashboardService {

    private api: string = CONTROLLERS.TENANTS.PAYMENT_PIAN_DASHBOARD;
    private apiPayment = CONTROLLERS.PAYMENTS.PAYMENT_PLAN;
    http: any;
    constructor(private apiService: ApiService) { }

    getPaymentPlanSnapshot(PaymentPlanDashboardReqCommand: PaymentPlanDashboardReqCommand): Observable<Response<PaymentPlanSnapshotResp>> {
        return this.apiService.post(
            `${this.api}/${ENDPOINTS.TENANTS.PAYMENTPLAN_DASHBOARD.PAYMENTPLAN_SNAPSHOT}`,
            PaymentPlanDashboardReqCommand
        );
    }

    getPaymentPlanMethod(PaymentPlanDashboardReqCommand: PaymentPlanDashboardReqCommand): Observable<Response<PaymentPlanMethodResp>> {
        return this.apiService.post(
            `${this.api}/${ENDPOINTS.TENANTS.PAYMENTPLAN_DASHBOARD.PAYMENTPLAN_METHOD}`,
            PaymentPlanDashboardReqCommand
        );
    }

    getPaymentPlanType(PaymentPlanDashboardReqCommand: PaymentPlanDashboardReqCommand): Observable<Response<PaymentPlanTypeResp>> {
        return this.apiService.post(
            `${this.api}/${ENDPOINTS.TENANTS.PAYMENTPLAN_DASHBOARD.PAYMENTPLAN_TYPE}`,
            PaymentPlanDashboardReqCommand
        );
    }
    getTimeBasedSnapshot(PaymentPlanDashboardReqCommand: PaymentPlanDashboardReqCommand): Observable<Response<TimeBasedSnapshotResp>> {
        return this.apiService.post(
            `${this.api}/${ENDPOINTS.TENANTS.PAYMENTPLAN_DASHBOARD.TIMEBASED_SNAPSHOT}`,
            PaymentPlanDashboardReqCommand
        );
    }

    // getActionRequired(practiceId: number): Observable<Response<PlaymentPlanActionRequiredResponse>> {
    //     const url = `${ENDPOINTS.PAYMENTS.PAYMENT_PLAN_DASHBOARD.GET_ACTION_REQUIRED}?practiceId=${practiceId}`;
    //     return this.http.get<PlaymentPlanActionRequiredResponse>(`${apiPayment}/${url}`);
    // }
    getActionRequired(practiceId: number): Observable<Response<PlaymentPlanActionRequiredResponse>> {
        const url = `${ENDPOINTS.PAYMENTS.PAYMENT_PLAN.GET_ACTION_REQUIRED}?practiceId=${practiceId}`;
        return this.apiService.get(`${this.apiPayment}/${url}`);
    }




}
